<template>
<!-- This template version is for 1-3 interactive boxes above the video frame -->
  <div class="hpHero" @mousemove="onMouseMovement" >    
    
    <!-- SCROLLDOWN ICON ANIMATION -->
    <div class="iscroll">
      <div class="icon_scroll"></div>
    </div>

    <ul class="hpHeroCollage">
      <li class="hpBox1">
        <!-- MAIN LEFT BOX -->
        <video :src="itemsData[hoverIndex].video" data-src="" poster="" title="" autoplay="" loop="" muted="" ></video>        
        <div class="box1Content px-2xl">
          <img class="boxLogoImg" src="img/temp_xdlogo.png" />
          <h4>New. Sharp. Every Single Time</h4>
        </div>
      </li>
      <li class="hpBox2">
        <!-- TOP/RIGHT BOX -->
        <!-- <img class="bgImg" :src="itemsData[1].bg" /> -->
        <video :src="itemsData[1].video" data-src="" poster="" title="" autoplay="" loop="" muted="" >
        </video>             
        <div class="boxContent">
            <span>A Call for Clinical Case Submissions: An  Invitation to Shine</span>
            <span>Submit your clinical case!</span>
        </div>
      </li>
      <li class="hpBox3">
        <!-- BOTTOM/RIGHT BOX -->
        <img class="bgImg" :src="itemsData[2].bg" />
        <div class="boxContent">
            <span>A Call for Clinical Case Submissions: An  Invitation to Shine</span>
            <span>Submit your clinical case!</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
        //
        showBoxes:false,
        timerInt:null,
        timerCounter:0,
        hoverIndex:0,
        videoBgSrc:'',
        itemsData:
        [
          {
            "title":"",
            "subtitle":"New. Sharp. Every Single Time",
            "url":"https://www.mis-implants.com/products/kits-and-tools/xd-drills",
            "img":"logos/logo_xd.png",
            "video":"video/xd_sharp_1080.mp4",
            "bg":""
          },
          {
            "title":"",
            "subtitle":"Tissue-Level Screw-Retained Solution",
            "url":"https://www.mis-implants.com/products/prosthetic-options/screw-retained/connect-system",
            "img":"img/_temp/hpTemp1.png",
            "video":"video/mis_connect.mp4",
            "bg":"img/_temp/hpTemp1.png"
          },
          {
            "title":"",
            "subtitle":"Save the Date!",
            "url":"https://www.mis-implants.com/products/prosthetic-options/screw-retained/connect-system",
            "img":"img/_temp/hpTemp2.png",
            "video":"",
            "bg":"img/_temp/hpTemp2.png"
          }

          /*
          {
            "title":"Welcome to MIS Implants",
            "subtitle":"Making it Simple for over 25 years",
            "url":"https://www.mis-implants.com/products/kits-and-tools/xd-drills",
            "img":""
          }*/
        ]        
    };
  },
  mounted() {
    var vm = this;
    this.timerInt = setInterval(() => {
        vm.timerCounter++;

        //hide boxes after 3 seconds of mouse not moving:
        if(vm.timerCounter>3)
        {
            vm.showBoxes=false;
        }
    }, 1000);
  },
  watch: {
  },
  computed: {
  },
  methods: {
    onMouseMovement()
    {
        var vm = this;
        vm.timerCounter=0;
        vm.showBoxes = true;
    },
    onItemOver(index)
    {
        this.hoverIndex = index;
    }
  }
};
</script>

<style scoped>
    .hpHero
    {
        display: block;
        position: relative;
        height: 100vh;
        overflow: hidden;
    }
    .hpHero .hpHeroContent
    {
        position: absolute;
        bottom: 0px;
        height: auto;
        width: 100%;
        text-align: center;
        padding: 10vw 10vw 3vw 10vw;        
    }
    .hphGrid
    {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0px;
        gap: 20px;
        flex-wrap: wrap;
        margin: 0px;       
        /* opacity: 1; transition: all ease 0.4s; */
    }
    .hphGrid.active
    {
        /* opacity: 1; */
    }
    .hphItem
    {
        cursor: pointer !important;
        flex: 1;
        height: 12vw;
        background-color: rgba(255, 255, 255, 0.1);        
        /* clip-path: inset(0 50% 0 0); */
        opacity: 0;        
        transition: all ease 1s;
        transition-delay: calc(var(--index) * 0.1s);        
    }
    .hphItem.active
    {
        opacity: 1;
        /* clip-path: inset(0 0 0 0); */
    }
    .hphItem:hover
    {
        background-color: rgba(11, 11, 11, 0.75);
    }
    .hpHero .hpHeroContent img
    {
        width: 40vh;
        height: auto;
    }
    .hpHero .hpHeroContent h4
    {
        padding-top:10px;
        text-align: center;
        font-weight: 500 !important;
        font-size: 1.5vw;
    }
    .hpHeroInner
    {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000;
    }
    .hpHeroCollage
    {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000;
        display: grid;
        grid-template-columns: 70% 30%;
        grid-template-rows: 1fr 1fr;
        padding: 0px;
        list-style: none;
    }
    .hpHeroCollage li:nth-child(1)
    {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 3;
        background-color: #000;
    }
    .hpHeroCollage li
    {
      position: relative;
      overflow: hidden;
    }
    .hpHeroCollage li video
    {
      opacity: 0.5;
    }
    .hpHeroCollage li img
    {      
      opacity: 0.4;
    }

    /* main box */
    .box1Content
    {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .boxLogoImg
    {
      opacity: 1 !important;
      width: 17vw;
      height: auto;
    }

    .hpHeroCollage li .boxContent
    {      
      position: absolute;
      bottom: 0px;
      color:#fff;
      padding: 3vw;
      opacity: 0;
      transition: all ease 0.4s;
    }
    .hpHeroCollage li:hover .boxContent
    {      
      opacity: 1;
    }

    .hpHeroCollage li .bgImg
    {
        opacity: 0.3;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;   
        transition: all ease 0.5s;     
    }    
    .hpHeroCollage li:hover .bgImg
    {
        opacity: 0.6;
        transform: scale(1.05);
    }

    .hpHeroCollage li .boxContent span:nth-child(1)
    {
        display: block;
        color: #fff;
        font-size: 24px;
        line-height: 24px;
        letter-spacing: -1px !important;
        font-weight: 300 !important;
    }
    .hpHeroCollage li .boxContent span:nth-child(2)
    {
        display: block;
        color: #e1e1e1;
        font-size: 14px;
        padding-top: 8px;
        font-weight: 400 !important;
    }

    .hpHeroCollage li:nth-child(2)
    {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 2;
        background-color: #000;
    }
    .hpHeroCollage li:nth-child(3)
    {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 2;
        grid-row-end: 3;
        background-color: #000;
    }
    .hpHeroCollage .bgImg
    {
        opacity: 0.3;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;        
    }
    .hpHeroCollage video
    {
        opacity: 1;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;        
    }
    .textLink span
    {
      color: #fff;
      font-weight: 500 !important;
      border-radius: 30px;
      padding: 10px 20px;
      border: solid 2px #fff;
    }
    .btnWrap
    {
      clear: both;
      padding-top: 2vw;
    }

    .hphInner
    {
      position: relative;
      padding: 2.5vw;
      height: 100%;
      cursor: pointer !important;
    }
    .hphItem:hover .hph-arrow
    {
      opacity: 0.6;
      transform: translateX(-50%);
    }
    .hph-arrow
    {
      position: absolute;
      bottom: 2.5vw;
      right: 1.25vw;
      color: #fff;
      font-size: 1.3vw;
      transform: translateX(-100%);
      opacity: 0;
      transition: all ease 0.4s;
    }
    .hph-elements
    {
      position: absolute;
      bottom: 2.5vw;
    }
    .hph-img
    {
        clear: both;
        text-align: left;
        padding-bottom: 1px;
    }
    .hph-img img
    {
        height: 2.6vw !important;
        width: auto !important;
    }
    .hph-title
    {
        color: #fff;
        font-weight: 300 !important;
        text-align: left;
        font-size: clamp(2vw,2.4vw,4.5rem);
        line-height: clamp(2vw,2.2vw,4.5rem);
        padding-bottom: 10px;
        letter-spacing: -1px !important;
    }
    .hph-subtitle
    {
        text-align: left;
        color: #fff;
        font-weight: 300 !important;
    }

    .iscroll
    {
      width: 20px;
      height: 36px;
      position: absolute;
      left: 50%;
      z-index: 10;
      transform: translate(-50%,0%);
      bottom: 3vw;
    }    
</style>


<style lang="stylus">
  .icon_scroll
    position: absolute
    left: 0%
  .icon_scroll:before
    position: absolute
    left: 50%
  .icon_scroll
    width: 20px
    height: 36px
    //margin-left: -20px
    //top: 50%
    //margin-top: -35px
    box-shadow: inset 0 0 0 1px #fff
    border-radius: 25px
  .icon_scroll:before
    content: ''
    width: 4px
    height: 8px
    background: #fff
    margin-left: -2px
    top: 8px
    border-radius: 4px
    animation-duration: 2s
    animation-iteration-count: infinite
    animation-name: icon_scroll

  @keyframes icon_scroll
    0%
      opacity: 1
    100%
      opacity: 0
      transform: translateY(8px)
</style>
